'use es6';

import { wrapReduxAction } from 'AdsUI/lib/ActionWrapper';
import * as EntityManagementData from 'AdsUI/data/EntityManagementData';
import { EntityTypes } from 'AdsUI/lib/Constants';
export const fetchPages = (network, accountId) => dispatch => wrapReduxAction(EntityManagementData.getPages.bind(EntityManagementData, network, accountId), 'PAGES_FETCH', {
  dispatch,
  transform: entities => ({
    entities
  }),
  allParams: {
    network,
    accountId
  }
});
export const createKeyword = ({
  adAccountId,
  campaignId,
  adGroupId,
  keywordText,
  matchType
}) => dispatch => {
  return wrapReduxAction(EntityManagementData.createKeyword.bind(EntityManagementData, {
    adAccountId,
    campaignId,
    adGroupId,
    keywordText,
    matchType
  }), 'KEYWORD_CREATE', {
    allParams: {
      adAccountId,
      campaignId,
      adGroupId,
      keywordText,
      matchType
    },
    transform: id => ({
      id
    }),
    returnPromise: true,
    dispatch
  });
};
export const createKeywords = (adAccountId, campaignId, adGroupId, keywords) => dispatch => wrapReduxAction(EntityManagementData.createKeywords.bind(EntityManagementData, adAccountId, campaignId, adGroupId, keywords.map(keyword => keyword)), 'KEYWORD_BULK_CREATE', {
  dispatch,
  returnPromise: true
});
export const deleteEntity = ({
  network,
  entityType,
  adAccountId,
  campaignId,
  adGroupId,
  keywordId
}) => dispatch => {
  const apiCall = entityType === EntityTypes.ADGROUP ? EntityManagementData.deleteAdGroup.bind(this, {
    network,
    adAccountId,
    campaignId,
    adGroupId
  }) : entityType === EntityTypes.KEYWORD ? EntityManagementData.deleteKeyword.bind(this, {
    network,
    adAccountId,
    campaignId,
    adGroupId,
    keywordId
  }) : null;

  if (!apiCall) {
    throw new Error('not implemented');
  }

  return wrapReduxAction(apiCall, 'ENTITY_DELETE', {
    dispatch,
    allParams: {
      entityType,
      network,
      adAccountId,
      campaignId,
      adGroupId,
      keywordId
    }
  });
};